import { render } from "./SearchFixed.vue?vue&type=template&id=6337180a&scoped=true"
import script from "./SearchFixed.vue?vue&type=script&lang=js"
export * from "./SearchFixed.vue?vue&type=script&lang=js"

import "./SearchFixed.vue?vue&type=style&index=0&id=6337180a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6337180a"]])

export default __exports__